// extracted by mini-css-extract-plugin
export var activityContainer = "_ip-0";
export var typingIndicatorContainer = "_ip-1";
export var typingIndicatorDot = "_ip-2";
export var wave = "_ip-3";